
<template>
<section>
  <div class="columns">
    <div class="Cal">
      <chc-input v-model="data.company_name" label="Company Name" :required="true" :error="errors.company_name"></chc-input>
      <chc-input v-model="data.address_street" label="Address" :required="true" :error="errors.address_street"></chc-input>
      <chc-input v-model="data.address_city" label="City" :required="true" :error="errors.address_city"></chc-input>
      <chc-input v-model="data.address_state" label="State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list" :required="true" :error="errors.address_state"></chc-input>
      <chc-input v-model="data.address_zip" label="Zip" format="zip" :required="true" :error="errors.address_zip"></chc-input>
      <chc-input v-model="data.email" label="Email" :required="true" :error="errors.email"></chc-input>
      <chc-input v-model="data.phone" label="Phone" :required="true" :error="errors.phone"></chc-input>
      <chc-input v-model="data.fax" label="Fax"></chc-input>
      <towing-company-tiers :data="data"></towing-company-tiers>
      <div class="error-block">
        <span v-if="hasErrors" class="error-message error-block">
          There were errors processing the form. Please fix the fields above.
        </span>
      </div>
      <div class="field buttons save submit-section">
          <input @click="submit" type="submit" class="btn" value="Save Changes">
        <a class="secondary-action" @click="cancel">Cancel</a>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import TowingCompanyTiers from '@/components/TowingCompany/TowingCompanyTiers'

export default {
  name: 'TowingCompanyAdd',
  data () {
    return {
      data: {
        company_name: '',
        address_street: '',
        address_city: '',
        address_state: '',
        address_zip: '',
        email: '',
        phone: '',
        fax: '',
        towing_fees_included_in_sale_price: true,
        towing_tiers: [
          {
            bottom: null,
            top: null,
            fee: null
          }
        ],
        status: 'active'
      },
      errors: [],
      hasErrors: false,
    }
  },
  props: [],
  methods: {
    submit () {
      store.functions.towingCompanies.createTowingCompany(this.fixData(this.data), (errors) => {
        this.errors = errors
        this.hasErrors = true
      }).then(() => {
        this.$emit('refresh')
        this.$emit('close')
      })
    },
    fixData (data) {
      if (!this.data.towing_fees_included_in_sale_price) {
        return Object.assign({}, data, { towing_tiers: JSON.stringify(data.towing_tiers) })
      } else {
        return Object.assign({}, data, { towing_tiers: JSON.stringify([]) })
      }
    },
    cancel () {
      this.$emit('close')
    }
  },
  components: {
    TowingCompanyTiers
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingCompanyAdd.vue